/*
 * Mijntuinklompen.nl, 16 okt 2026 (themakopie mtk-fundament)
 * 28A: geen voorgeselecteerde maat op de productpagina, en de vaste koopbalk op mobiel.
 *
 * Werking
 * - De maatradio blijft technisch aangevinkt (de variant-JS van het thema werkt dan zoals altijd:
 *   kleurwissel, prijs, foto's). De klasse mtk-maat-kies op <variant-picker> laat hem er onaangevinkt uitzien.
 * - Zolang er geen maat gekozen is, toont de knop "Kies je maat". Klikken voegt niets toe: de maatkeuze
 *   krijgt een rode rand en de melding "Kies eerst je maat", en de pagina scrolt ernaartoe.
 * - Na een klik op een maat: "In winkelwagen – maat X" en de knop werkt zoals altijd (product-form.js).
 * - Met ?variant= in de URL, bij één variant of zonder maatoptie doet dit script niets aan de knop.
 * - Alle listeners hangen één keer aan document (event delegation), dus ook na het vervangen van
 *   sectie-inhoud door de variant-JS ontstaan er geen dubbele listeners.
 * - Leverregel (17 okt 2026, besluiten 27A/34/79A): de regel in het zekerhedenblok (snippet mtk-leverregel)
 *   toont zonder gekozen maat de algemene tekst en na de maatkeuze de tekst van die variant
 *   (voorraad: "Voor 17:00 besteld, vandaag verzonden"; nabestelling: "Levertijd 2–3 werkdagen").
 */
(function () {
  if (window.mtkMaatkeuze) return;
  window.mtkMaatkeuze = true;

  var KIES = 'Kies je maat';
  var MELDING = 'Kies eerst je maat';
  var state = {}; // per sectie-id: { managed: bool, chosen: bool }

  function mainSection(el) {
    if (!el || !el.closest) return null;
    if (el.closest('.js-quickbuy, .cc-featured-product, quick-add-drawer')) return null;
    return el.closest('.cc-main-product');
  }

  function sectionId(section) {
    var p = section && section.querySelector('.js-product[data-section-id]');
    return p ? p.dataset.sectionId : null;
  }

  function picker(section) {
    return section.querySelector('variant-picker[data-mtk-maatkeuze]');
  }

  function sizeFieldset(root) {
    return root ? root.querySelector('[data-mtk-maat]') : null;
  }

  function addBtn(section) {
    return section.querySelector('.js-product-form-main [name="add"]');
  }

  function checkedSize(root) {
    var fs = sizeFieldset(root);
    var input = fs && fs.querySelector('.js-option:checked');
    return input ? input.value : '';
  }

  function textFor(st, root) {
    if (!st.chosen) return KIES;
    var size = checkedSize(root);
    return size ? 'In winkelwagen – maat ' + size : null;
  }

  function setBtnText(btn, text) {
    if (!btn || !text) return;
    btn.dataset.addToCartText = text;
    if (!btn.disabled) btn.textContent = text;
  }

  /* Leverregel: kies de algemene of de varianttekst die de server in data-attributen meegeeft */
  function setLeverEl(el, chosen) {
    if (!el || !el.hasAttribute('data-mtk-lever-algemeen')) return;
    var text = chosen ? el.getAttribute('data-mtk-lever-variant') : el.getAttribute('data-mtk-lever-algemeen');
    var span = el.querySelector('[data-mtk-lever-tekst]');
    if (span) span.textContent = text || '';
    el.hidden = !text;
  }

  function setLever(root, chosen) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('[data-mtk-lever]')) setLeverEl(root, chosen);
    Array.prototype.forEach.call(root.querySelectorAll('[data-mtk-lever]'), function (el) { setLeverEl(el, chosen); });
  }

  function init(section) {
    var id = sectionId(section);
    if (!id || state[id]) return state[id];
    var vp = picker(section);
    var managed = !!(vp && sizeFieldset(vp));
    state[id] = {
      managed: managed,
      chosen: !(vp && vp.dataset.mtkMaatkeuze === 'true')
    };
    return state[id];
  }

  function hideMessage(section) {
    var fs = sizeFieldset(section);
    if (!fs) return;
    fs.classList.remove('mtk-maat-fout');
    var m = fs.querySelector('.mtk-maat-melding');
    if (m) m.remove();
  }

  function showMessage(section) {
    var fs = sizeFieldset(section);
    if (!fs) return;
    fs.classList.add('mtk-maat-fout');
    if (!fs.querySelector('.mtk-maat-melding')) {
      var m = document.createElement('p');
      m.className = 'mtk-maat-melding';
      m.setAttribute('role', 'alert');
      m.textContent = MELDING;
      fs.appendChild(m);
    }
    fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var first = fs.querySelector('.js-option');
    if (first) {
      try { first.focus({ preventScroll: true }); } catch (e) { /* oudere browsers */ }
    }
    clearTimeout(fs._mtkTimer);
    fs._mtkTimer = setTimeout(function () { fs.classList.remove('mtk-maat-fout'); }, 2500);
  }

  function choose(section, st, input) {
    st.chosen = true;
    var vp = picker(section);
    if (vp) vp.classList.remove('mtk-maat-kies');
    hideMessage(section);
    // Leverregel meteen tonen als de getoonde regel bij deze maat hoort (bijv. klik op de al aangevinkte maat).
    // Hoort hij bij een andere variant, dan blijft de algemene regel staan tot de nieuwe HTML er is.
    var vid = input && input.dataset ? input.dataset.variantId : '';
    Array.prototype.forEach.call(section.querySelectorAll('[data-mtk-lever-vid]'), function (el) {
      if (vid && el.getAttribute('data-mtk-lever-vid') === vid) setLeverEl(el, true);
    });
    setBtnText(addBtn(section), textFor(st, section));
    updateBar(section);
  }

  /* Klik of wissel op een maat = maat gekozen */
  function onOption(evt) {
    var input = evt.target;
    if (!input || !input.matches || !input.matches('.js-option')) return;
    if (!input.closest('[data-mtk-maat]')) return;
    var section = mainSection(input);
    if (!section) return;
    var st = init(section);
    if (!st || !st.managed || st.chosen) return;
    choose(section, st, input);
  }
  document.addEventListener('click', onOption, true);
  document.addEventListener('change', onOption, true);

  /* Knop zonder maat: niets toevoegen, maat aanwijzen */
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.matches || !form.matches('.js-product-form-main')) return;
    var section = mainSection(form);
    if (!section) return;
    var st = init(section);
    if (!st || !st.managed || st.chosen) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    showMessage(section);
  }, true);

  /* Vervangen inhoud (kleurwissel of andere maat): zet de staat terug in de nieuwe HTML */
  document.addEventListener('on:variant:before-replace-element', function (evt) {
    var d = evt.detail || {};
    var section = mainSection(d.toReplace);
    if (!section || !d.replaceWith) return;
    var st = init(section);
    if (!st || !st.managed) return;
    setLever(d.replaceWith, st.chosen);
    var newVp = d.replaceWith.matches && d.replaceWith.matches('variant-picker') ? d.replaceWith : d.replaceWith.querySelector('variant-picker');
    if (newVp) newVp.classList.toggle('mtk-maat-kies', !st.chosen);
    var btn = d.replaceWith.querySelector ? d.replaceWith.querySelector('[name="add"]') : null;
    if (btn) {
      var root = newVp || section;
      var text = st.chosen ? (checkedSize(root) ? 'In winkelwagen – maat ' + checkedSize(root) : null) : KIES;
      if (text) {
        btn.dataset.addToCartText = text;
        if (!btn.disabled) btn.textContent = text;
      }
    }
  });

  document.addEventListener('on:variant:change', function (evt) {
    var section = mainSection(evt.target);
    if (!section) return;
    var st = init(section);
    if (!st || !st.managed) return;
    if (!st.chosen) {
      // Nog geen maat gekozen: geen ?variant= in de URL laten staan (anders telt een herlaad als gekozen)
      var url = new URL(window.location.href);
      if (url.searchParams.has('variant')) {
        url.searchParams.delete('variant');
        window.history.replaceState({}, '', url.pathname + (url.search ? url.search : '') + url.hash);
      }
      setBtnText(addBtn(section), KIES);
    } else {
      setBtnText(addBtn(section), textFor(st, section));
    }
    setLever(section, st.chosen);
    setTimeout(function () { updateBar(section); }, 30);
  });

  /* ---------- Vaste koopbalk (mobiel) ---------- */
  function bar(section) {
    var id = sectionId(section);
    return id ? document.getElementById('mtk-koopbalk-' + id) : null;
  }

  function updateBar(section) {
    var b = bar(section);
    if (!b) return;
    var st = init(section) || { managed: false, chosen: true };
    var btn = addBtn(section);
    var kbBtn = b.querySelector('[data-mtk-kb-knop]');
    if (btn && kbBtn) {
      kbBtn.textContent = btn.textContent.trim();
      kbBtn.disabled = btn.disabled;
    }
    var price = section.querySelector('.product-info__price .price__current .js-value');
    var kbPrice = b.querySelector('[data-mtk-kb-prijs]');
    if (price && kbPrice && price.innerHTML.trim()) kbPrice.innerHTML = price.innerHTML;
    var kbSize = b.querySelector('[data-mtk-kb-maat]');
    if (kbSize) {
      var size = st.managed && st.chosen ? checkedSize(section) : '';
      kbSize.textContent = size ? 'Maat ' + size : '';
    }
  }

  function cookieDialogOpen() {
    var dlg = document.getElementById('CybotCookiebotDialog');
    if (!dlg) return false;
    var cs = window.getComputedStyle(dlg);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && dlg.offsetHeight > 0;
  }

  function setupBar(b) {
    if (b.dataset.mtkReady) return;
    b.dataset.mtkReady = '1';
    var section = b.closest('.cc-main-product') || document.querySelector('.cc-main-product');
    if (!section) return;
    init(section);
    var target = section.querySelector('product-form');
    var past = false;

    function render() {
      var show = past && !cookieDialogOpen();
      // Geen focus achterlaten in een verborgen balk (toegankelijkheid)
      if (!show && b.contains(document.activeElement)) document.activeElement.blur();
      b.inert = !show;
      b.classList.toggle('is-zichtbaar', show);
      b.setAttribute('aria-hidden', show ? 'false' : 'true');
      var kbBtn = b.querySelector('[data-mtk-kb-knop]');
      if (kbBtn) kbBtn.tabIndex = show ? 0 : -1;
    }

    // Alleen tonen als de hoofdknop BOVEN het beeld is verdwenen (dus voorbij gescrold).
    // Een scroll-listener (per frame gebundeld) in plaats van IntersectionObserver: die mist een snelle sprong.
    var ticking = false;
    function check() {
      ticking = false;
      if (!target || !target.isConnected) target = section.querySelector('product-form');
      if (!target) return;
      var nowPast = target.getBoundingClientRect().bottom < 0;
      if (nowPast !== past) {
        past = nowPast;
        render();
      }
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(check);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    check();

    ['CookiebotOnDialogDisplay', 'CookiebotOnAccept', 'CookiebotOnDecline', 'CookiebotOnLoad'].forEach(function (n) {
      window.addEventListener(n, function () { setTimeout(render, 50); });
    });

    b.querySelector('[data-mtk-kb-knop]').addEventListener('click', function () {
      var st = init(section);
      if (st && st.managed && !st.chosen) {
        showMessage(section);
        return;
      }
      var btn = addBtn(section);
      if (btn && !btn.disabled) btn.click();
    });

    updateBar(section);
  }

  function boot() {
    document.querySelectorAll('[data-mtk-koopbalk]').forEach(setupBar);
    document.querySelectorAll('.cc-main-product').forEach(function (s) {
      var st = init(s);
      if (st && st.managed) {
        setBtnText(addBtn(s), textFor(st, s));
        setLever(s, st.chosen);
      }
      updateBar(s);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
